var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "col-md-3", attrs: { "data-cy": _vm.product.dn } },
    [
      _vm.product.ty == _vm.PRODUCT_TYPES.Product
        ? _c("div", { staticClass: "bgProd productChoice" }, [
            _c(
              "div",
              {
                staticClass:
                  "prodImg d-flex justify-content-center align-items-center",
                on: {
                  click: function ($event) {
                    return _vm.showItemDetails()
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: `${_vm.shop.ShopId}/carte/${_vm.item.tid}` },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("img", {
                      class: {
                        "img-fit": _vm.shop.info.display.stretchProductImage,
                      },
                      attrs: {
                        src: _vm.UrlService.imagePath(
                          _vm.product.ShopId,
                          _vm.product.imt
                        ),
                        alt: _vm.product.dn,
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src = "dist/assets/no-img.png"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "clyo-search" }),
                  ]
                ),
                _vm._v(" "),
                _vm.product.Promo ? _c("promo-grid-view") : _vm._e(),
                _vm._v(" "),
                (_vm.product.allergens && _vm.product.allergens.length) ||
                (_vm.product.consumables && _vm.product.consumables.length)
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.bottom-end",
                            value: _vm.infoAllergens(_vm.product),
                            expression: "infoAllergens(product)",
                            modifiers: { "bottom-end": true },
                          },
                        ],
                        staticClass:
                          "flex-center-center size-wh-30 bg-grey1 color-white m-10 mt-15 radius-50 pos-absolute top-0 right-0",
                      },
                      [
                        _c("i", {
                          staticClass: "fie-icon_warning-eat fsize-18",
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "prodDetails",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showItemDetails()
                  },
                },
              },
              [
                _c("div", { staticClass: "bgDetails" }, [
                  _c("div", { staticClass: "addCart" }, [
                    _vm.shop.canOrder
                      ? _c(
                          "a",
                          {
                            staticClass: "cursor-pointer",
                            attrs: { "data-cy": "add-to-cart" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.selectItem()
                              },
                            },
                          },
                          [_vm._m(0)]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bottomProd",
                      staticStyle: { "border-top": "transparent" },
                    },
                    [
                      _c(
                        "h2",
                        { staticClass: "flex-center-center flex-column" },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.SentensizeString(_vm.product.dn))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.shop.info.display.vignetteDesc
                            ? _c("p", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.truncate(
                                        _vm.stripHtml(_vm.product.dd),
                                        _vm.DISPLAY_LENGTH.mosaic.product.desc
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.product.dp
                            ? _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ShopService.prix(_vm.product.dp, " ")
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.product.ty == _vm.PRODUCT_TYPES.Category
        ? _c("div", { staticClass: "bgProd categoryChoice" }, [
            _c(
              "div",
              {
                staticClass:
                  "prodImg d-flex justify-content-center align-items-center",
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.UrlService.itemHref(_vm.item, _vm.shop),
                    },
                  },
                  [
                    _c("img", {
                      class: {
                        "img-fit": _vm.shop.info.display.stretchProductImage,
                      },
                      attrs: {
                        src: _vm.UrlService.imagePath(
                          _vm.product.ShopId,
                          _vm.product.imt
                        ),
                        alt: _vm.product.dn,
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src = "dist/assets/no-img.png"
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.product.Promo ? _c("promo-grid-view") : _vm._e(),
                _vm._v(" "),
                (_vm.product.allergens && _vm.product.allergens.length) ||
                (_vm.product.consumables && _vm.product.consumables.length)
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.bottom-end",
                            value: _vm.infoAllergens(_vm.product),
                            expression: "infoAllergens(product)",
                            modifiers: { "bottom-end": true },
                          },
                        ],
                        staticClass:
                          "flex-center-center size-wh-30 bg-grey1 color-white m-10 mt-15 radius-50 pos-absolute top-0 right-0",
                      },
                      [
                        _c("i", {
                          staticClass: "fie-icon_warning-eat fsize-18",
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("a", {
              attrs: {
                id: "link-to-" + _vm.item.tid,
                href: _vm.UrlService.itemHref(_vm.item, _vm.shop),
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "prodDetails",
                on: {
                  click: function ($event) {
                    return _vm.clickOnLink("#link-to-" + _vm.item.tid)
                  },
                },
              },
              [
                _c("div", { staticClass: "bgDetails" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bottomProd",
                      staticStyle: {
                        height: "100%",
                        "border-top": "transparent",
                      },
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center align-items-center",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.UrlService.itemHref(
                                  _vm.item,
                                  _vm.shop
                                ),
                              },
                            },
                            [_vm._v(_vm._s(_vm.product.dn))]
                          ),
                          _vm._v(" "),
                          _vm.product.dd != 0 &&
                          _vm.shop.info.display.vignetteDesc
                            ? _c("p", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.truncate(
                                        _vm.stripHtml(_vm.product.dd),
                                        _vm.DISPLAY_LENGTH.mosaic.product.desc
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.product.dp
                            ? _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ShopService.prix(_vm.product.dp, " ")
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.product.ty == _vm.PRODUCT_TYPES.Menu
        ? _c("div", { staticClass: "bgProd menuChoice" }, [
            _c(
              "div",
              {
                staticClass:
                  "prodImg d-flex justify-content-center align-items-center",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showItemDetails()
                  },
                },
              },
              [
                _c("div", [
                  _c("img", {
                    class: {
                      "img-fit": _vm.shop.info.display.stretchProductImage,
                    },
                    attrs: {
                      src: _vm.UrlService.imagePath(
                        _vm.product.ShopId,
                        _vm.product.imt
                      ),
                      alt: _vm.product.dn,
                    },
                    on: {
                      error: function ($event) {
                        $event.target.src = "dist/assets/no-img.png"
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "clyo-search" }),
                ]),
                _vm._v(" "),
                _vm.product.Promo ? _c("promo-grid-view") : _vm._e(),
                _vm._v(" "),
                (_vm.product.allergens && _vm.product.allergens.length) ||
                (_vm.product.consumables && _vm.product.consumables.length)
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.bottom-end",
                            value: _vm.infoAllergens(_vm.product),
                            expression: "infoAllergens(product)",
                            modifiers: { "bottom-end": true },
                          },
                        ],
                        staticClass:
                          "flex-center-center size-wh-30 bg-grey1 color-white m-10 mt-15 radius-50 pos-absolute top-0 right-0",
                      },
                      [
                        _c("i", {
                          staticClass: "fie-icon_warning-eat fsize-18",
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "prodDetails",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showItemDetails()
                  },
                },
              },
              [
                _c("div", { staticClass: "bgDetails" }, [
                  _c("div", { staticClass: "addCart" }, [
                    _vm.shop.canOrder
                      ? _c(
                          "a",
                          {
                            attrs: { "data-cy": "add-to-cart" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.UrlService.go({
                                  name: "carte",
                                  params: { tid: _vm.item.tid },
                                })
                              },
                            },
                          },
                          [_vm._m(1)]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bottomProd",
                      staticStyle: { "border-top": "transparent" },
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-center align-items-center",
                        },
                        [
                          _c("b", [_vm._v(_vm._s(_vm.product.dn))]),
                          _vm._v(" "),
                          _vm.product.dd != 0 &&
                          _vm.shop.info.display.vignetteDesc
                            ? _c("p", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.truncate(
                                        _vm.stripHtml(_vm.product.dd),
                                        _vm.DISPLAY_LENGTH.mosaic.product.desc
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.product.dp
                            ? _c("span", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ShopService.prix(_vm.product.dp, " ")
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-stack fa-lg" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "clyo clyo-plus fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-stack fa-lg" }, [
      _c("i", { staticClass: "fa fa-circle fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "clyo clyo-plus fa-stack-1x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }